import { getSlicePercentage } from './plot-data.utils.js';
import { ColorToken } from '../../core/types/color-palette.js';
import {
  SUBPIXEL_SLICES_FILL_COLOR,
  SUBPIXEL_SLICES_ID,
} from '../constants.js';
import { InternalSliceData } from '../types/internal/pie-chart.js';

export const groupSubpixelSlices = (
  slices: InternalSliceData[],
  padAngle: number,
): InternalSliceData[] => {
  let subpixelSlicesValueSum = 0;
  let totalAbsoluteValueSum = 0;
  const newSlices: InternalSliceData[] = [];
  const groupedSlices: InternalSliceData[] = [];
  const padAngleDeg = (padAngle * 180) / Math.PI;
  for (const slice of slices) {
    const sliceAngleDeg = (slice.relativeValue / 100) * 360;
    if (sliceAngleDeg <= padAngleDeg) {
      subpixelSlicesValueSum += slice.value;
      groupedSlices.push(slice);
    } else {
      newSlices.push(slice);
    }
    totalAbsoluteValueSum += slice.value;
  }
  if (subpixelSlicesValueSum > 0) {
    const aggregatedSubpixelSliceColorToken: ColorToken = {
      Default: SUBPIXEL_SLICES_FILL_COLOR,
    };
    const aggregatedSubpixelSlice: InternalSliceData = {
      category: '',
      value: subpixelSlicesValueSum,
      color: aggregatedSubpixelSliceColorToken,
      id: SUBPIXEL_SLICES_ID,
      groupedSlices,
      relativeValue: getSlicePercentage(
        subpixelSlicesValueSum,
        totalAbsoluteValueSum,
      ),
    };
    newSlices.push(aggregatedSubpixelSlice);
  }
  return newSlices;
};
